import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import Legend from "./Legend";
import { buildAdditionalCss, buildLegend, getPieChartOptions } from "./utils";

function ChartItem(props) {
    const {
        data = [],
        singleAllocation = false,
        sum = 0,
        numberFormat = (num) =>
            num.toLocaleString("en-US", { minimumFractionDigits: 2 }),
        percentFormat = (num) =>
            `${num.toLocaleString("en-US", { maximumFractionDigits: 2 })}`,
        disableLegend = false,
        index = null,
        hideValues = false,
        chartSize,
        showCHFValue = false,
    } = props;
    const css = buildAdditionalCss(data, index);

    return (
        <div
            style={css}
            className={`highcharts-pie ${
                singleAllocation ? "highcharts-pie_single-allocation" : ""
            }`}
        >
            <HighchartsReact
                containerProps={{ className: "highcharts-react-container" }}
                highcharts={Highcharts}
                options={getPieChartOptions(
                    data,
                    sum,
                    singleAllocation,
                    percentFormat,
                    chartSize, showCHFValue
                )}
            />
            {!disableLegend && (
                <Legend
                    legend={buildLegend(
                        data,
                        sum,
                        singleAllocation,
                        percentFormat
                    )}
                    numberFormat={numberFormat}
                    singleAllocation={singleAllocation}
                    hideValues={hideValues}
                />
            )}
        </div>
    );
}


export default ChartItem;
